// extracted by mini-css-extract-plugin
module.exports = {"unit":"8px","colorPrimary":"#276749","colorWhite":"#FFFFFF","colorGreyDark":"#2D3748","option":"select-option__option____3l0rK","selected":"select-option__selected____1WXt7"};